var map = {
	"./chinese.png": 332,
	"./dutch.png": 333,
	"./english.png": 331,
	"./french.png": 334,
	"./german.png": 335,
	"./greek.png": 336,
	"./italian.png": 337,
	"./japanese.png": 338,
	"./korean.png": 339,
	"./portuguese.png": 341,
	"./russian.png": 340,
	"./spanish.png": 343,
	"./turkish.png": 342
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 759;